import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { NavigationItem } from '@/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'header-navDrawer',
  props: {
  navigationItems: Array as () => NavigationItem[],
  drawer: Boolean
},
  emits: ['update:drawer'],
  setup(__props, { emit: __emit }) {

const AuthStore = useAuthStore()

const props = __props

const drawer = computed(() => {
  return props.drawer
})

const emit = __emit

const toggleDrawer = () => {
  emit('update:drawer', !props.drawer)
}

function signOut () {
  const updatedDrawer = !props.drawer
  emit('update:drawer', updatedDrawer)
  useAuthStore().setIsAuthenticated(false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
    app: "",
    temporary: "",
    location: "right"
  }, {
    default: _withCtx(() => [
      (_unref(AuthStore).isAuthenticated)
        ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigationItems, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.title,
                  link: "",
                  onClick: toggleDrawer
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: item.href,
                      class: "custom-button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_v_list_item, { link: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { onClick: signOut }, {
                    default: _withCtx(() => [
                      _createTextVNode("Logga ut")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})